export const PhoneIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5413 3.83374C13.5413 3.81083 13.5232 3.79192 13.5003 3.79175H6.50031C6.4773 3.79175 6.45831 3.81073 6.45831 3.83374V16.1667C6.45831 16.1898 6.47729 16.2087 6.50031 16.2087H13.5003C13.5232 16.2086 13.5413 16.1897 13.5413 16.1667V3.83374ZM10.8333 4.57495C11.1784 4.57495 11.4582 4.85483 11.4583 5.19995C11.4583 5.54513 11.1785 5.82495 10.8333 5.82495H9.16632C8.82133 5.82473 8.54132 5.54499 8.54132 5.19995C8.54139 4.85497 8.82137 4.57517 9.16632 4.57495H10.8333ZM14.7913 16.1667C14.7913 16.88 14.2135 17.4586 13.5003 17.4587H6.50031C5.78695 17.4587 5.20831 16.8801 5.20831 16.1667V3.83374C5.20831 3.12038 5.78694 2.54175 6.50031 2.54175H13.5003C14.2135 2.54192 14.7913 3.12049 14.7913 3.83374V16.1667Z"
      fill="currentColor"
    />
  </svg>
);
